import { symptomCategories, symptomLevels } from '@/mocks/questionnaire';
import type { Answers } from '@/pages/home/types';
import SectionCard from '@/pages/home/components/SectionCard';

interface SymptomStepProps {
  answers: Answers;
  onAnswer: (name: string, value: string | string[]) => void;
  totalScore: number;
  ratedCount: number;
}

export default function SymptomStep({
  answers,
  onAnswer,
  totalScore,
  ratedCount,
}: SymptomStepProps) {
  return (
    <>
      {symptomCategories.map((category, index) => (
        <SectionCard key={category.title} index={index + 1} title={category.title}>
          <div className="divide-y divide-secondary-200/70 -mt-1">
            {category.items.map((item) => {
              const current = typeof answers[item.name] === 'string' ? (answers[item.name] as string) : '';
              return (
                <div
                  key={item.name}
                  className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 py-3"
                >
                  <span className="text-sm text-foreground-800 leading-relaxed">{item.label}</span>
                  <div className="flex items-center gap-1.5 shrink-0">
                    {symptomLevels.map((level) => {
                      const active = current === level.label;
                      return (
                        <button
                          key={level.value}
                          type="button"
                          onClick={() => onAnswer(item.name, active ? '' : level.label)}
                          className={`w-11 h-8 rounded-full text-xs font-medium border transition-all cursor-pointer ${
                            active
                              ? 'bg-primary-500 text-background-50 border-primary-500'
                              : 'bg-background-50 text-foreground-500 border-secondary-200 hover:border-primary-300 hover:text-primary-600'
                          }`}
                        >
                          {level.label}
                        </button>
                      );
                    })}
                  </div>
                  <input type="hidden" name={item.name} value={current} readOnly />
                </div>
              );
            })}
          </div>
        </SectionCard>
      ))}

      <div className="bg-primary-50 rounded-xl border border-primary-200/60 px-4 py-3 flex items-center justify-between">
        <div className="flex items-center gap-2 text-sm text-primary-700">
          <i className="ri-bar-chart-box-line text-base"></i>
          <span>已评 {ratedCount} / 12 项</span>
        </div>
        <span className="text-sm font-semibold text-primary-600">当前得分 {totalScore} / 36</span>
      </div>
    </>
  );
}